import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, LinearProgress, Dialog } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../store';
import { MessageType } from '../models';
import * as Store from '../store/Message';

export default function MessageDialog() {
    const message = useSelector(Store.selectors.currentMessage);
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);

    function handleConfirm() {
        if (!message) {
            return;
        }

        if (message && message.type === MessageType.Confirm) {
            // run the on confirm handler
            if (message.onConfirm) {
                setLoading(true);
                message.onConfirm()
                    .then((success: any) => {
                        setLoading(false);
                        dispatch(Store.actionCreators.dismiss(message));
                    })
                    .catch(() => {
                        setLoading(false);
                    });
            }
        } else {
            dispatch(Store.actionCreators.dismiss(message));
        }
    }

    function handleDismiss() {
        if (message) {
            dispatch(Store.actionCreators.dismiss(message));
        }
    }

    return (
        <Dialog open={!!message}>
            <DialogTitle>{message ? message.title : ''}</DialogTitle>
            <DialogContent>
                {loading && <LinearProgress />}
                <DialogContentText id="alert-dialog-description">
                    {message ? message.message : ''}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleConfirm} color="primary">
                    {message && message.type === MessageType.Confirm ? 'Yes' : 'Ok'}
                </Button>
                {message && message.type === MessageType.Confirm && <Button onClick={handleDismiss} color="primary">
                    Cancel
                </Button>}
            </DialogActions>
        </Dialog>
    );
}